import React from 'react';
import { BaseFilterCheckboxSelect } from '../base/BaseFilterCheckboxSelect';
import { ISelectOption } from '../../../domain/saved-filters/interface';

interface IProgramUtilityFilterSelectProps {
    value: string[];
    onChange: (value: string[]) => void;
    label?: string;
    height?: number;
    searchable?: boolean;
    disabled?: boolean;
    resizable?: boolean;
    options: ISelectOption<string>[];
}

export const ProgramUtilityFilterSelect: React.FC<IProgramUtilityFilterSelectProps> = ({
    options,
    value,
    onChange,
    label,
    height = 300,
    disabled = false,
}) => {
    return (
        <BaseFilterCheckboxSelect
            multiple
            resizable
            loading={false}
            searchable
            showSelectAllOption={false}
            selectedCountInLabel
            disabled={disabled}
            options={options}
            value={value}
            onChange={onChange}
            label={label}
            height={height}
        />
    );
};
